import http from '../utils/http'

export const getPicture = (data) => {
  return http.post('/captcha/get', data)
}

export const reqCheck = (data) => {
  return http.post('/captcha/check', data)
}

export const aesEncrypt = () => {}
